import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, filter, interval, mergeMap } from 'rxjs';
import { PollResponse } from '../model';
import { BankIdService } from '../api';

@Injectable()
export class BankIdPollingService {
  private bankIdService = inject(BankIdService);

  private readonly POLL_INTERVAL = 1000;
  private pollResponse: BehaviorSubject<PollResponse> = new BehaviorSubject<PollResponse>(null);
  private currentQrStartTokenCodeB64: string;

  public connect(id: string, sameDevice: boolean, idp: string): Observable<PollResponse> {
    this.startPolling(id, sameDevice, idp);

    return this.pollResponse.asObservable();
  }

  private startPolling(id: string, sameDevice: boolean, idp: string): void {
    interval(this.POLL_INTERVAL)
      .pipe(
        mergeMap(() => this.bankIdService.getStatus(id, sameDevice, this.currentQrStartTokenCodeB64, idp)),
        filter(result => result != null)
      )
      .subscribe(result => {
        this.currentQrStartTokenCodeB64 = result.qrStartTokenCodeB64;

        this.pollResponse.next(result);
      });
  }
}
